import {Component, Output, EventEmitter, ElementRef, HostListener, Input} from '@angular/core';
import {User} from '../../../../types/admin-data.types';
import {AccountPermissionsService} from '../../../../services/account-permissions.service';

@Component({
    selector: 'user-action-button',
    templateUrl: './action-button.component.html',
    styleUrls: ['./action-button.component.scss']
})
export class ActionButtonComponent {
    @Input() data: User;
    @Input() canDelete;
    @Output('onClick') clickOutput = new EventEmitter();

    public isShow: boolean = false;
    public userType: string = '';

    constructor(private elementRef: ElementRef,
                public accountPermissionsService: AccountPermissionsService) {
        this.userType = JSON.parse(localStorage.getItem('userData')).userType;
    }

    public toggle(): void {
        this.isShow = !this.isShow;
    }

    @HostListener('document:click', ['$event.target'])
    public hide(targetElement: HTMLElement): void {
        if (!this.elementRef.nativeElement.contains(targetElement)) {
            this.isShow = false;
        }
    }

    public onClick(type): void {
        this.clickOutput.emit({type, data: this.data});
    }

}




// WEBPACK FOOTER //
// /app/src/app/views/admin/user/action-button/action-button.component.ts